import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DynamicListColumn } from "../../../dashboard-area/dynamic-list/dynamic-list-column";
import { DynamicListRow } from "../../../dashboard-area/dynamic-list/dynamic-list-row";
import { SimplePipe } from "../../../dashboard-area/dynamic-list/simple.pipe";


const toBeFiltered: String[] = ["title", "description", "name", "date", "duration", "thingDefinition.name"];
@Component({
    selector: 'work-session-block',
    template: require('./work-session-block.component.html'),
    styles: [require('../../thing-troubleshooting/thing-troubleshooting-item.component.css'),
        require('../../alert-list/active-alert-list/alert-block.component.css')]
})
export class WorkSessionBlockComponent implements OnInit {

    @Input() workSession: any;

    @Input() duration: string;

    @Input() headers: DynamicListColumn[];

    @Input() workSessionData: DynamicListRow;

    @Input() expandable: boolean;

    @Output() goToWorkSessionDetailsEvent = new EventEmitter();

    showDetails: boolean = false;
    filteredHeaders: DynamicListColumn[];

    ngOnInit() {
        !this.expandable ? this.showDetails = true : null;
        this.filteredHeaders = this.headers.filter(el => !toBeFiltered.includes(el.name));
    }

    updateLayout(): void {
        this.showDetails = !this.showDetails;
    }

    getPipe(columnIndex: number): any {
        return this.headers[columnIndex].pipe || SimplePipe;
    }

    getValue(row: DynamicListRow, columnIndex: number) {
        return row.values[columnIndex];
    }

    checkFiltered(index: number): boolean {
        return !toBeFiltered.some(el => el == (this.headers[index].name || this.headers[index].label));
    }

    goToWorkSessionDetails(): void {
        this.goToWorkSessionDetailsEvent.emit(this.workSession.id);
    }

}